import { useId } from 'react'

export default function ChartPlaceholder({ connected, onConnect }) {
  const gradientId = useId().replace(/:/g, '')

  return (
    <div
      className="portfolio-chart-stage flex min-h-[420px] flex-1 max-mobile:min-h-[320px]"
      data-testid="portfolio-chart-stage"
    >
      <div className="portfolio-chart-stage-inner relative w-full">
        <div className="portfolio-chart-stage-frame flex size-full flex-col items-center justify-center">
          <span
            data-icon="true"
            className="portfolio-chart-svg-wrap absolute top-0 left-0 z-0 flex size-full shrink-0 items-center justify-center text-ink"
          >
            <svg
              viewBox="0 0 590 315"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="portfolio-chart-svg size-full"
            >
              <path
                className="portfolio-chart-grid"
                d="M0 0.75H590"
                stroke="var(--color-line)"
                strokeWidth="1.5"
                strokeDasharray="4 4"
              />
              <path
                className="portfolio-chart-grid"
                d="M0 48.75H590"
                stroke="var(--color-line)"
                strokeWidth="1.5"
                strokeDasharray="4 4"
              />
              <path
                className="portfolio-chart-grid"
                d="M0 96.75H590"
                stroke="var(--color-line)"
                strokeWidth="1.5"
                strokeDasharray="4 4"
              />
              <path
                className="portfolio-chart-grid"
                d="M0 144.75H590"
                stroke="var(--color-line)"
                strokeWidth="1.5"
                strokeDasharray="4 4"
              />
              <path
                className="portfolio-chart-grid"
                d="M0 192.75H590"
                stroke="var(--color-line)"
                strokeWidth="1.5"
                strokeDasharray="4 4"
              />
              <path
                className="portfolio-chart-grid"
                d="M0 240.75H590"
                stroke="var(--color-line)"
                strokeWidth="1.5"
                strokeDasharray="4 4"
              />
              <path
                className="portfolio-chart-grid"
                d="M0 288.75H590"
                stroke="var(--color-line)"
                strokeWidth="1.5"
                strokeDasharray="4 4"
              />
              <path
                className="portfolio-chart-fill"
                d="M24 224.75L79.2845 206.322C82.3038 205.315 85.5992 205.55 88.4458 206.973L136.264 230.882C140.884 233.192 146.464 232.286 150.116 228.634L203.16 175.59C203.719 175.031 204.331 174.529 204.989 174.091L259.117 138.006C262.198 135.951 266.055 135.435 269.568 136.606L317.658 152.636C321.601 153.95 325.943 153.131 329.135 150.471L384 104.75L439.117 68.0055C442.198 65.9514 446.055 65.4349 449.568 66.6059L497.658 82.6361C501.601 83.9503 505.943 83.1311 509.135 80.4706L564 34.75V314.75H24V224.75Z"
                fill={`url(#${gradientId})`}
              />
              <path
                className="portfolio-chart-line"
                d="M24 224.75L79.2845 206.322C82.3038 205.315 85.5992 205.55 88.4458 206.973L136.264 230.882C140.884 233.192 146.464 232.286 150.116 228.634L203.16 175.59C203.719 175.031 204.331 174.529 204.989 174.091L259.117 138.006C262.198 135.951 266.055 135.435 269.568 136.606L317.658 152.636C321.601 153.95 325.943 153.131 329.135 150.471L384 104.75L439.117 68.0055C442.198 65.9514 446.055 65.4349 449.568 66.6059L497.658 82.6361C501.601 83.9503 505.943 83.1311 509.135 80.4706L564 34.75"
                stroke="var(--color-faint)"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeDasharray="4 4"
              />
              <circle
                className="portfolio-chart-dot-halo"
                cx="564"
                cy="34.75"
                r="10"
                fill="currentColor"
                fillOpacity="0.2"
              />
              <circle
                className="portfolio-chart-dot"
                cx="564"
                cy="34.75"
                r="4"
                fill="currentColor"
              />
              <defs>
                <linearGradient
                  id={gradientId}
                  x1="294"
                  y1="34.75"
                  x2="294"
                  y2="314.75"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="currentColor" stopOpacity="0.05" />
                  <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
              </defs>
            </svg>
          </span>
          {!connected ? (
            <div className="portfolio-chart-note z-1 max-w-[70%] rounded-3xl bg-bg p-6 text-center text-ink shadow-chart-note">
              <span className="portfolio-chart-note-stack flex flex-col items-center gap-6 text-md max-mobile:m-auto">
                <span className="portfolio-chart-note-copy max-mobile:m-auto">
                  Please <span className="pointer-events-none">connect</span> your
                  wallet
                </span>
                <button
                  type="button"
                  data-testid="portfolio-chart-connect-wallet-button"
                  onClick={onConnect}
                  className="group inline-flex w-fit shrink-0 cursor-pointer items-center justify-center truncate rounded-pill text-sm/sm font-medium transition-all active:scale-[0.97] disabled:cursor-auto disabled:opacity-50 disabled:active:scale-100 bg-ink text-bg shadow-border-button-primary hover:bg-ink/90 active:bg-ink/80 disabled:hover:bg-ink disabled:active:bg-ink light:shadow-(--btn-primary-shadow) h-8 gap-2 p-2 max-mobile:min-h-(--control-h-lg) rounded-card px-4"
                >
                  <span>Connect Wallet</span>
                </button>
              </span>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}
